import { CheckCheck, ChevronLeft, ChevronRight, Search } from "lucide-react";

export const REASONS = [
  ["sin_tipo", "Sin tipo detectado"],
  ["sugerencia", "Sugerencia de cliente"],
  ["ambiguo", "Cliente ambiguo"],
  ["acta_pf", "Acta en persona física"],
  ["no_cliente", "Carpeta que no es cliente"],
  ["id_nombre", "ID y nombre no coinciden"],
  ["credito", "Crédito no coincide o aún no cargado"],
  ["eliminado", "Cliente eliminado"],
  ["fuera", "Fuera de carpeta de cliente"],
];

const Chip = ({ active, onClick, label, count, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${active ? "border-[#0f5ef7] bg-[#0f5ef7] text-white" : "border-[#dfe6f1] bg-white text-[#182235] hover:border-[#0f5ef7]"}`}>
    {label} <span className={active ? "opacity-80" : "text-[#5b667a]"}>({count})</span>
  </button>
);

export const BandejaFilters = ({ data, reason, onReason, query, onQuery, suggestions, onConfirmSuggestions }) => (
  <section className="tr-card space-y-3 p-4" data-testid="bandeja-filters">
    <div className="flex flex-wrap gap-2">
      <Chip active={!reason} onClick={() => onReason("")} label="Todos" count={data.count} testId="bandeja-reason-all" />
      {REASONS.filter(([k]) => data.reasons[k]).map(([k, label]) => (
        <Chip key={k} active={reason === k} onClick={() => onReason(k)} label={label} count={data.reasons[k]} testId={`bandeja-reason-${k}`} />
      ))}
    </div>
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative min-w-[220px] flex-1">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#5b667a]" />
        <input value={query} onChange={(e) => onQuery(e.target.value)} placeholder="Buscar carpeta…" className="tr-input pl-9" data-testid="bandeja-search-input" />
      </div>
      {suggestions > 0 && (
        <button type="button" onClick={onConfirmSuggestions} className="tr-btn-light px-3 py-2 text-sm" data-testid="bandeja-confirm-suggestions-button">
          <CheckCheck className="h-4 w-4" /> Confirmar todas las sugerencias visibles ({suggestions})
        </button>
      )}
    </div>
  </section>
);

export const Pager = ({ page, pages, total, onPage }) => (
  <nav className="flex items-center justify-between gap-3 text-sm text-[#5b667a]" data-testid="bandeja-pager">
    <span data-testid="bandeja-pager-info">Página {page} de {pages} · {total} {total === 1 ? "carpeta" : "carpetas"}</span>
    <div className="flex gap-2">
      <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)} className="tr-btn-light px-3 py-1.5 text-xs" data-testid="bandeja-pager-prev">
        <ChevronLeft className="h-3.5 w-3.5" /> Anterior
      </button>
      <button type="button" disabled={page >= pages} onClick={() => onPage(page + 1)} className="tr-btn-light px-3 py-1.5 text-xs" data-testid="bandeja-pager-next">
        Siguiente <ChevronRight className="h-3.5 w-3.5" />
      </button>
    </div>
  </nav>
);
